export class FetchNetworkCodePageLength {
  static readonly type = '[number] Fetch All';

  constructor(public payload: number) {
  }
}
